<template>
	<div id="app">
		<router-view :key="$route.path"></router-view>
	</div>
</template>

<script>
	import Role from '@/api/Role'

	export default {
		mounted () {
			Role.show().then(function (response) {
				if (response.data.data.is_main_office) {
					document.title = '予約管理ツール【本部】'
					return
				}

				if (response.data.data.is_branch_office) {
					document.title = '予約管理ツール【支社・支店・AM】'
					return
				}

				if (response.data.data.is_call_center) {
					document.title = '予約管理ツール【コールセンター】'
					return
				}

				if (response.data.data.is_admin_staff) {
					document.title = '予約管理ツール【スタッフ】'
					return
				}

				if (response.data.data.is_staff) {
					document.title = '予約管理ツール【スタッフ】'
				}
			})
		}
	}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue